(ns net.kestec.mhda-pilgrimage.public.page-structure
  (:require
    ["@mui/material/Grid2" :default Grid]
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Menu" :default Menu]
    ["@mui/material/Divider" :default Divider]
    ["@mui/material/MenuList" :default MenuList]
    ["@mui/material/IconButton" :default IconButton]
    ["@mui/material/MenuItem" :default MenuItem]
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Box" :default Box]

    ["@mui/icons-material/Menu" :default MenuIcon]
    ["@mui/icons-material/Logout" :default LogoutIcon]

    ["@mui/material/useMediaQuery" :default useMediaQuery]
    ["@mui/material/styles" :refer [useTheme]]

    [net.kestec.mhda-pilgrimage.db :as db]
    [net.kestec.mhda-pilgrimage.menu :refer [menu-items]]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    [reagent.core :as r]))

(def !el (r/atom nil))


(defn bar-menu [!anchor !open]
  (into [:> Menu
         {:anchor-el     @!anchor
          :open          @!open
          :anchor-origin {:vertical   "top"
                          :horizontal "left"}}]
        (menu-items)))

(defn name-part []
  [:> Grid {:size {:xs 12 :sm 6 :md 3}
            :sx   {:backgroundColor "var(--color-mhda-red)"
                   :color           "var(--color-mhda-red-text)"
                   :borderRight     "1px solid var(--color-mhda-red-text)"
                   :textAlign       "left"}}

   [:> Typography {:variant "h3" :style {:margin "6px 10px 0 10px"}} @(rf/subscribe [::db/get ::db/me :user_name])]
   [:> Typography {:variant "h5" :style {:margin "0 10px 0 10px"}}  @(rf/subscribe [::db/get ::db/me :user_group])] ;TODO MHDA

   ])

(defn title-part []
  [:> Grid {:size {:xs 12 :sm 6 :md 4}
            :sx   {:backgroundColor "var(--color-mhda-red)"
                   :color           "var(--color-mhda-red-text)"
                   :borderRight     "1px solid var(--color-mhda-red-text)"
                   :textAlign       "right"}}

   [:> Typography {:variant "h3" :style {:margin "6px 10px 0 0"}} (str "Wallfahrt Anmelde Formular")]
   [:> Typography {:variant "h4" :style {:margin "0 10px 0 0"}} (str "ROM 2026")]])



(defn header []
  (let [!open (r/atom false)
        me @(rf/subscribe [::db/get ::db/me :person])
        md? (useMediaQuery (.up (.-breakpoints (useTheme)) "md"))]
    [:> Grid {:container true
              :direction "row"
              }

     [:> Grid {:size {:xs 10 :sm 11 :md 4}
               :sx   {:padding "10px"}}
      [:a {:href "/" :class "mhda-logo"}]]

     (when-not md?
       [:> Grid {:size {:xs 2 :sm 1}
                 :sx   {:padding "10px"
                        :textAlign "right"}}
        [:> IconButton
         {:onClick (fn []
                     (reset! !open (not @!open)))
          :ref     #(reset! !el %)
          }
         [:> MenuIcon {:style {:color "var(--color-mhda-red)"} :fontSize "large"}]
         [bar-menu !el !open]]])






     [title-part]
     [name-part]
     (when md?
       [:> Grid {:size {:md 1}
                 :sx   {:padding         "10px"
                        :backgroundColor "var(--color-mhda-red)"
                        :textAlign "right"
                        }}
        ;[:> Box {:size {:md 1}
        ;         :sx   {:backgroundColor "var(--color-mhda-red)"}}]
        [:> IconButton
         {:onClick (fn []
                     (reset! !open (not @!open)))
          :ref     #(reset! !el %)
          }
         [:> MenuIcon {:style {:color "var(--color-mhda-red-text)"} :fontSize "large"}]
         [bar-menu !el !open]]])




     ]))

(defn footer []
  [:> Grid {:container true
            :class     "footer"
            :direction "row"
            :spacing   0
            :sx        {:background-color "#333333"
                        :height           "30px"
                        :color            "white"}}
   [:> Grid {:size {:xs 12}}
    [:> Typography {:component "div" :align "center" :width "100%"} "MALTESER Hospitaldienst 2026 -- bei Problemen melden Sie sich bitte bei Sebastian Ernest " [:a {:style {:color "lightblue"} :href "mailto:rom@malteser.at"} "rom@malteser.at"] ]]

   ])

(defn base-page [page]
  [:> Paper {:sx {:margin "0em auto 0em auto" :max-width "1680px" :min-height "100vh"}}
   [:div {:style {:display "flex" :flex-direction "column" :min-height "100vh"}}
    [:div {:style {:flex-basis "60px"}}
     [:f> header]]
    [:div {:style {:flex-basis "30%"
                   :flex-grow  1}}

     [:> Grid {:container true
               :direction "row"
               :spacing   0}

      [:> Grid {:size {:xs 12}
                :sx   {:padding "7px"}}
       page]
      ]]
    [:div {:style {:flex-basis "30px"}}
     [footer]]]])
